import React from 'react';
import SkeletonBox from './SkeletonBox';
import './FormCardSkeleton.css';

const FormCardSkeleton = () => (
  <div className="formCardSkeleton">
    <div className="formCardSkeleton__card">
      <SkeletonBox width="220px" height="26px" />
      <SkeletonBox width="320px" height="14px" className="formCardSkeleton__mt8" />

      <div className="formCardSkeleton__row">
        <SkeletonBox width="100%" height="56px" radius="10px" />
        <SkeletonBox width="100%" height="56px" radius="10px" />
      </div>
      <div className="formCardSkeleton__row">
        <SkeletonBox width="100%" height="56px" radius="10px" />
        <SkeletonBox width="100%" height="56px" radius="10px" />
      </div>

      <SkeletonBox width="100%" height="90px" radius="10px" className="formCardSkeleton__mt16" />

      <div className="formCardSkeleton__footer">
        <SkeletonBox width="140px" height="46px" radius="42px" />
      </div>
    </div>
  </div>
);

export default FormCardSkeleton;
